const artist = (state = {}, action) => {
  switch (action.type) {
    case 'ARTIST_LOGIN':
      return {
        ...state,
        artist: action.payload.artist ? action.payload.artist : null
      }

    case 'SET_ARTIST':
      return {
        ...state,
        artist: action.payload.artist,
        artistInfo: action.payload.artist
      }
    case 'UPDATE_ARTIST':
      return {
        ...state,
        updateSuccess: action.payload.artist && true,
        aritst: action.payload.artist,
        artistInfo: action.payload.artist
      }
    case 'ARTIST_PROJECTS':
      return {
        ...state,
        ...action.payload
      }
    case 'ARTIST_REPRESENTATION':
      return {
        ...state,
        represented: action.payload.representation_request,
        token: action.payload.token
      }

    case 'SEARCH_ARTIST':
      return {
        errors: action.error ? action.payload.error : null,
        ...action.payload
      }
    case 'RESET_SEARCH': 
      return {
        ...state,
        errors: null,
        artists: null
      }
    case 'UNLOAD_PROFILE_FORM':
      return {
        ...state,
        artists: []
      }
    case 'FINDME_UNLOAD':
      return {} 
      
    case 'CHECKIN_QUESTIONS':
      return {
        ...state,
        ...action.payload
      }
    case 'GET_PROJECT_ARTIST':
      return {
        ...state,
        checkin: action.payload
      }

    case 'SUBMIT_CHECKIN':
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        errorMessage: action.error ? action.payload.message : (action.payload.error || null),
        checkinSuccess: action.error || action.payload.message ? false : true,
        // redirectTo: action.error ? null : '/checkin/success',
        artist: action.payload
      }

    case 'CLEAR_CHECKIN': 
      return {
        checkinSuccess: false
      }
      
    case 'REGISTER_AGENCY':
      return {
        agency: action.payload.agency
      }
    case 'CLEAR_AGENCIES':
      return {
        agencies: [],
      }

    case 'SEARCH_AGENCY':
      return {
        searchingAgency: true,
        ...action.payload        
      }
    case 'CLIENT_REGISTER_ARTIST':
    case 'REGISTER_ARTIST':
      window.localStorage.setItem('artist_jwt', JSON.stringify(action.payload))
      return {
        artist: Object.assign({}, action.payload.artist, { meta: action.payload.meta }),
        error: action.error ? action.payload : null,
        fromRegistration: true,
        redirectTo: action.error ? null : '/artist/dashboard',
      }
    case 'PUBLIC_UPLOAD':
      console.log('reducer-artist', action)
      return {
        artist: Object.assign({}, action.payload.artist, { meta: action.payload.meta })
      }
    case 'ARTIST_PAGE_UNLOADED':
    case 'REGISTER_PAGE_UNLOADED':
      return {
        ...state,
        redirectTo: null
      }

    case 'CHECKIN_UNLOADED': 
      return {
        ...state,
        artist: null
      }
    default:
      return state;
  }
};


export default artist


// WEBPACK FOOTER //
// ./src/reducers/artist.js